import { useEffect } from 'react';

// Custom hook for injecting script in a specific functional component
const useScript = (url) => {
    useEffect(
        () => {
            const script = document.createElement('script');

            script.src = url;
            script.async = true;

            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        },
        [url]
    );
};

export default useScript;
